import React from 'react';
import ProgramSlideCommunicationMonitorModal from './ProgramSlideCommunicationMonitorModal';
import {
  ackPresentationCommunicationMonitorOpen,
  readPresentationCommunicationMonitorSnapshot,
  subscribePresentationCommunicationMonitor,
  type PresentationCommunicationMonitorSnapshot,
} from '../../utils/presentationCommunicationMonitorBridge';

/**
 * MainLayout(원탭)에 마운트: 프레젠테이션 탭의 「모니터링」 요청을 수신해 모달 표시.
 * 스냅샷은 LS/BroadcastChannel으로만 갱신 — 별도 fetch 없음.
 */
const ProgramSlideCommunicationMonitorHost: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [snapshot, setSnapshot] = React.useState<PresentationCommunicationMonitorSnapshot | null>(
    null
  );
  const openRef = React.useRef(open);
  openRef.current = open;

  React.useEffect(() => {
    return subscribePresentationCommunicationMonitor({
      onSnapshot: (next) => {
        setSnapshot((prev) => {
          if (!openRef.current) {
            // 모달이 닫혀 있어도 최신 스냅샷은 보관(다음 오픈용)
            return next;
          }
          if (!prev || next.updatedAt >= prev.updatedAt) return next;
          return prev;
        });
      },
      onOpen: ({ requestId, snapshot: next }) => {
        setSnapshot(next);
        setOpen(true);
        ackPresentationCommunicationMonitorOpen(requestId);
      },
    });
  }, []);

  React.useEffect(() => {
    if (!open) return;
    const cached = readPresentationCommunicationMonitorSnapshot();
    if (cached) setSnapshot(cached);
  }, [open]);

  return (
    <ProgramSlideCommunicationMonitorModal
      open={open}
      snapshot={snapshot}
      onClose={() => setOpen(false)}
    />
  );
};

export default ProgramSlideCommunicationMonitorHost;
